export default "__VITE_ASSET__RVvNHNyl__"